import type { FaireProductEntity } from "../../entity_types/product";

export const p_np3j84da9j: FaireProductEntity = {
  token: "p_np3j84da9j",
  type: "product",
  name: "Gourmetnut, Power Up 14, SWEET HEAT, 6/12oz(K)",
  brandToken: "b_22qxjttyk7",
  brandName: "NuEats",
  imageUrl:
    "https://cdn.faire.com/fastly/0a7d3b199587e34cefb34e2d34192de73a987c1b48c9dce7d6b673cd14bc360e.png",
  galleryImageUrls: [],
  priceDollars: 9.01,
  description:
    "More Than Your Average Trail Mix - Our carefully selected blend of pecans, cranberries, walnuts, raisins, blueberries, and dark chocolate create protein snacks with a taste that is out of this world. Wholesome, simple ingredients make this snack mix the perfect way to indulge without the guilt! We use 52% Cacao rich dark chocolate that melts in your mouth! Dark chocolate is a powerful source of antioxidants & is a much better alternative than milk chocolate, which is higher in sugar & calories.",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:15.650Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
